import RedirectLinkComponent from "../Elements/RedirectLinkComponent";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import ProjectItem from "./ProjectItem";
import React from "react";

export default class ClientProjectItem extends ProjectItem {
  static FieldsToShowInDataTable() {
    return [
      { label: "Project ID", orderById: "CfId", data: ClientProjectItem.idFunction },
      { label: "Name", orderById: "CfName", data: "CfName" },
      { label: "Start On", orderById: "CfStartDate", data: "CfStartDate" },
      { label: "End On", orderById: "CfEndDate", data: "CfEndDate" },
      { label: "Service Type", orderById: "CfLstname", data: "CfLstname" },
      { label: "Project Manager", orderById: "CfProjectManagerName", data: "CfProjectManagerName" },
      {
        label: " ",
        orderById: "",
        data: ProjectItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        path="projects"
        tooltipText={item.CfId}
        isFigmaStyle={true}
        text={item.CfId}
        keyValuePairs={[
          { key: "OfficeName", value: "" },
          { key: "ProjectIdOrName", value: item.CfId },
        ]}
      />
    );
  }

  static DateFields = ["CfStartDate", "CfEndDate", "CfMod"];
}
